let SettingBox = function() {	
	if (!this.SettingBox == "") {
		this.$modal.show("hello-world");
	}
};
export default SettingBox;
